import * as yup from "yup";

export const submitVoucherValidation = yup.object().shape({
  documents: yup.array().of(
    yup.object().shape({
      date: yup.object().shape({ 
        value: yup.date().required("Date is required") 
      }),
      head: yup.object().shape({ 
        value: yup.string().required("Head is required") 
      }),
      amount: yup.object().shape({
        value: yup.number()
          .typeError('Invalid amount')
          .positive('Must be positive')
          .min(0, 'Must be at least zero')
          .required('Required')
          .test('is-positive', 'Must be greater than zero', (value) => value > 0)
          .test('is-decimal', 'Must have at most two decimal places', (value) => {
            if (value === undefined || value === null) return true; // Allow undefined or null
            const decimalCount = value.toString().split('.')[1]?.length || 0;
            return decimalCount <= 2;
          }),
      }),
      comment: yup.object().shape({ 
        value: yup.string().required("Comment is required") 
      }),
      file: yup.object().shape({ 
        value: yup.mixed().required("File attachment is required") 
      }),
    })
  ).required("Please select at least one document"),
  // description: yup.string().required("Voucher Description is required"),
});
